// "use client";

// import * as React from "react";
// import * as DialogPrimitive from "@radix-ui/react-dialog";
// import { cn } from "../../lib/utils";

// const NAVBAR_HEIGHT = 60;
// const EXCLUDE_ATTR = "[data-sheet-exclude]";

// function isExcludedTarget(target) {
//   if (!target) return false;
//   return !!target.closest(EXCLUDE_ATTR);
// }

// export const Sheet = ({ open, onOpenChange, ...props }) => {
//   React.useEffect(() => {
//     if (open) {
//       document.body.style.overflow = "hidden";
//     } else {
//       document.body.style.overflow = "";
//     }
//     return () => {
//       document.body.style.overflow = "";
//     };
//   }, [open]);

//   return (
//     <DialogPrimitive.Root modal={false} open={open} onOpenChange={onOpenChange} {...props} />
//   );
// };

// export const SheetTrigger = DialogPrimitive.Trigger;
// export const SheetClose = DialogPrimitive.Close;
// export const SheetPortal = DialogPrimitive.Portal;

// export const SheetOverlay = React.forwardRef(({ className, ...props }, ref) => (
//   <DialogPrimitive.Overlay
//     ref={ref}
//     className={cn(
//       `fixed left-0 right-0 bottom-0 top-[${NAVBAR_HEIGHT}px] z-[9000] bg-black/60 backdrop-blur-sm`,
//       "data-[state=open]:animate-fade-in-0 data-[state=closed]:animate-fade-out-0",
//       className
//     )}
//     {...props}
//   />
// ));
// SheetOverlay.displayName = DialogPrimitive.Overlay.displayName;

// export const SheetContent = React.forwardRef(
//   ({ className, side = "right", children, ...props }, ref) => (
//     <SheetPortal>
//       <SheetOverlay />
//       <DialogPrimitive.Content
//         ref={ref}
//         onPointerDownOutside={(event) => {
//           const target = event.target;
//           if (isExcludedTarget(target)) event.preventDefault();
//         }}
//         onInteractOutside={(event) => {
//           const target = event.target;
//           if (isExcludedTarget(target)) event.preventDefault();
//         }}
      
//         className={cn(
//           // ✅ overflow-y-auto 제거 (여기선 고정해야 함)
//           `fixed top-[${NAVBAR_HEIGHT}px] bottom-0 z-[9050] flex flex-col bg-neutral-950 text-white shadow-xl`,
//           "will-change-transform will-change-opacity transition-transform duration-300",
//           side === "right" &&
//             "right-0 w-full sm:w-[860px] md:w-[980px] border-l border-neutral-800",
//           side === "left" &&
//             "left-0 w-full sm:w-[860px] md:w-[980px] border-r border-neutral-800",
//           "data-[state=open]:animate-slide-in-from-right data-[state=closed]:animate-slide-out-to-right",
//           className
//         )}
//         {...props}
//       >
//         <div className="overflow-y-auto h-[calc(100vh-88px)] p-8 space-y-6">
//           {children}
//         </div>
//       </DialogPrimitive.Content>
//     </SheetPortal>
//   )
// );
// SheetContent.displayName = DialogPrimitive.Content.displayName;


"use client";

import * as React from "react";
import * as DialogPrimitive from "@radix-ui/react-dialog";
import { cn } from "../../lib/utils";

const EXCLUDE_ATTR = "[data-sheet-exclude]";

function isExcludedTarget(target) {
  if (!target) return false;
  return !!target.closest(EXCLUDE_ATTR);
}

export const Sheet = ({ open, onOpenChange, ...props }) => {
  React.useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  return (
    <DialogPrimitive.Root modal={false} open={open} onOpenChange={onOpenChange} {...props} />
  );
};

export const SheetTrigger = DialogPrimitive.Trigger;
export const SheetClose = DialogPrimitive.Close;
export const SheetPortal = DialogPrimitive.Portal;

export const SheetOverlay = React.forwardRef(({ className, ...props }, ref) => (
  <DialogPrimitive.Overlay
    ref={ref}
    className={cn(
      "fixed inset-0 z-[9000] bg-black/70 backdrop-blur-sm",
      "data-[state=open]:animate-fade-in-0 data-[state=closed]:animate-fade-out-0",
      
      className
    )}
    {...props}
  />
));
SheetOverlay.displayName = DialogPrimitive.Overlay.displayName;

export const SheetContent = React.forwardRef(
  ({ className, side = "right", children, ...props }, ref) => (
    <SheetPortal>
      <SheetOverlay />
      <DialogPrimitive.Content
        ref={ref}
        onPointerDownOutside={(event) => {
          const target = event.target;
          if (isExcludedTarget(target)) event.preventDefault();
        }}
        onInteractOutside={(event) => {
          const target = event.target;
          if (isExcludedTarget(target)) event.preventDefault();
        }}
        className={cn(
          // ✅ top-[60px] 제거 → 툴바와 내용이 딱 붙게
          "fixed inset-y-0 z-[9050] flex flex-col bg-neutral-950 text-white shadow-xl",
          "backdrop-blur-lg bg-neutral-950/100",
          "will-change-transform will-change-opacity transition-transform duration-300",
          side === "right" &&
            "right-0 w-full sm:w-[860px] md:w-[980px] border-l border-neutral-800",
          side === "left" &&
            "left-0 w-full sm:w-[860px] md:w-[980px] border-r border-neutral-800",
          "data-[state=open]:animate-slide-in-from-right data-[state=closed]:animate-slide-out-to-right",
          className
        )}
        {...props}
      >
        {/* ✅ 스크롤 되는 부분 */}
        <div className="flex-1 overflow-y-auto no-scrollbar p-8 space-y-6">
          {children}
        </div>
      </DialogPrimitive.Content>
    </SheetPortal>
  )
);
SheetContent.displayName = DialogPrimitive.Content.displayName;